import React from 'react'
import $ from 'jquery'
import '../utility/csrf'
import GlobalBanner from '../common/globalBanner'
import Amount from '../common/amount'
import SubHeader from '../common/subHeader'
import NextButton from '../common/nextButton'
import CancelAndReturn from '../common/cancelAndReturn'
import GuestButton from '../guest/guestButton'
import templateData from '../utility/getTemplateData'

import appStore from '../stores/AppStore'
import appActions from '../actions/AppActions'

import { handleLogIn, handleGuest, handleTokenReuse } from '../utility/helper'

import * as FPT from '../utility/fpt'

let currentState = templateData.currentState
let LandingPage = React.createClass({

	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	getInitialState() {

		return {
			donationAmount: appStore.getDonationAmount(),
			donationSymbol: appStore.getDonationSymbol(),
			donationCode: appStore.getDonationCode(),

			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			isEditable: templateData.donationAmountEditable,
			guestRedirectUrl: templateData.guestRedirectUrl
		};
	},

	componentDidMount() {
		appActions.updateCurrentPage({ currentPage: 'landing' });
		$('.spinneroverlay').hide();
	},

	handleAmountChange (amount) {
		appActions.changeAmount({ amount: amount });
	},

	getFPTDATA() {
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	},

	handleGuest (event) {
		let donationAmount = appStore.getDonationAmount()
		if (donationAmount && parseFloat(donationAmount) >= 0.01) {
			// Tracking click event with data. 'Pay by card with amount'
			FPT.trackLinkClick('donateWithCard')
		}
		handleGuest(this)
	},

	handleNext (event) {
		let donationAmount = appStore.getDonationAmount()
		if (donationAmount && parseFloat(donationAmount) >= 0.01) {
			FPT.trackLinkClick('donateWithPayPal')
		}

		handleLogIn()
	},

	render() {

		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.hasLogo ? <GlobalBanner /> : null}
					<SubHeader
						label={this.state.subHeaderLabel}/>
					<Amount amount={this.state.donationAmount}
						symbol={this.state.donationSymbol}
						code={this.state.donationCode}
						isEditable={this.state.isEditable}
						handleAmount={this.handleAmountChange}/>
					<p className="err_update_amount text-center">Some thing went wrong, please try after some time</p>
					<NextButton
						handleNext={this.handleNext}/>
					<GuestButton
						handleGuest={this.handleGuest}/>
					<CancelAndReturn />
				</div>
			</div>
		)
	}
})

export default React.createClass({
	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	getInitialState: function() {

		return {
			displayLanding: currentState ? false : true
		};
	},

	componentDidMount() {

		if (currentState) {
			this.context.router.push(currentState)
		} else {
			handleTokenReuse();
		}
	},

	componentWillUnmount() {},

	render() {
		return (
			<div>
				{this.state.displayLanding ? <LandingPage /> : null}
			</div>
			)
	}
})



// WEBPACK FOOTER //
// ./landing/landing.js